'use client';
import { createContext, useMemo, useContext } from 'react';
import { jsx } from 'react/jsx-runtime';

// src/hooks/use-loose-context.tsx
var createLooseContext = (rootComponentName, defaultContext) => {
  const Context = createContext(defaultContext);
  const Provider = (props) => {
    const { children, ...context } = props;
    const value = useMemo(
      () => context,
      // eslint-disable-next-line react-hooks/exhaustive-deps
      Object.values(context)
    );
    return /* @__PURE__ */ jsx(Context.Provider, { value, children });
  };
  const useLooseContext = () => {
    const context = useContext(Context);
    if (context)
      return context;
    if (defaultContext !== void 0)
      return defaultContext;
    return void 0;
  };
  Provider.displayName = rootComponentName + "Provider";
  return [Provider, useLooseContext];
};
var use_loose_context_default = createLooseContext;

export { use_loose_context_default as default };
